<template>
  <div class="container">
    <!-- <van-swipe @change="onChange" :loop="false" width="100vw" height="60vw" v-show="obj.img">
      <van-swipe-item v-for="item in obj.img" :key="item.index">
        <img :src="item" alt="" >
      </van-swipe-item>
      <template #indicator>
        <div class="custom-indicator">{{ current + 1 }}/{{total}}</div>
      </template>
    </van-swipe> -->
    <img
      :src="obj.img"
      v-show="obj.img"
      style="width: 100vw; height: 60vw; object-fit: cover"
      alt=""
    />
    <van-divider
      :style="{ fontWeight: 'bold', fontSize: '16px', color: 'black' }"
      >{{ obj.name }}</van-divider
    >
    <div class="intro" v-html="obj.intro"></div>
    <van-divider
      :style="{ fontWeight: 'bold', fontSize: '16px', color: 'black' }"
      >负责人</van-divider
    >
    <div style="padding: 5px 20px">
      <div class="flexdiv">
        <p v-if="obj.level == 1">主任：{{ obj.fuze_name }}</p>
        <p v-else-if="obj.level == 2">所长：{{ obj.fuze_name }}</p>
        <p v-else>站长：{{ obj.fuze_name }}</p>
      </div>
    </div>
    <van-divider
      :style="{ fontWeight: 'bold', fontSize: '16px', color: 'black' }"
      >其他信息</van-divider
    >
    <div style="padding: 5px 20px">
      <div class="flexdiv" @click="daohang">
        <p>所在地址：{{ obj.address }}</p>
        <!-- <van-icon name="location-o" /> -->
      </div>
      <a :href="'tel:' + obj.chuanzhen">
        <div class="flexdiv">
          <p>联系方式：{{ obj.chuanzhen }}</p>
          <van-icon name="phone-o" />
        </div>
      </a>
    </div>
    <van-divider
      :style="{ fontWeight: 'bold', fontSize: '16px', color: 'black' }"
      v-if="listxnjg.length"
      >下辖机构</van-divider
    >
    <!-- to add 辖内机构 class:xnjg -->
    <div class="xnjg" v-if="listxnjg.length && obj.level == 1">
      <div style="width: 100%; display: flex; flex-wrap: wrap">
        <div
          v-for="item in listxnjg"
          class="suo"
          :key="item.id"
          @click="routerto(item.id_target)"
        >
          <img
            src="//pic-cdn.bigdatajy.com/wenming/static/img/flag.png"
            alt=""
          />
          <p>{{ item.name }}</p>
        </div>
      </div>
    </div>
    <!-- <v-touch v-on:swipeleft="numadd" v-on:swiperight="numminuse" class="wrapper">
      <div class="menu-container" ref="menuContainer"> -->
    <div class="xnjg" v-if="listxnjg.length && obj.level == 2">
      <div class="arrow" @click="numminuse()">
        <van-icon name="arrow-left" />
      </div>
      <div class="center">
        <div
          v-for="(item, index) in listxnjg"
          :key="index"
          v-show="index >= (num - 1) * 5 && index <= num * 5 - 1"
          @click="routerto(item.id_target)"
        >
          <p
            style="
              margin-right: 2em;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
            "
          >
            {{ item.name }}
          </p>
          <p v-if="item.count" style="white-space: nowrap">
            内设{{ item.count }}个实践站
          </p>
        </div>
      </div>
      <div class="arrow" @click="numadd()">
        <van-icon name="arrow" />
      </div>
    </div>
    <!-- </div>
    </v-touch> -->
    <div class="topic">
      <p>近期资讯</p>
      <p @click="urlchange('resentzx')">更多</p>
    </div>
    <div
      v-for="(item, index) in list"
      :key="item.id"
      class="list"
      @click="linketo(item.id, item.type, item.link)"
      v-show="index < 3"
    >
      <div class="left">
        <img :src="item.img" alt="" />
      </div>
      <div class="right">
        <div class="flex" style="width: 100%">
          <span class="title">#{{ item.tag }}#</span>
          <div class="flex">
            <img
              src="//pic-cdn.bigdatajy.com/wenming/static/img/book.png"
              class="book"
              alt=""
            />
            <span>{{ item.read }}</span>
          </div>
        </div>
        <p class="info">{{ item.title }}</p>
        <p class="unit">{{ item.org_name }}</p>
        <p class="date">{{ item.post_date }}</p>
      </div>
    </div>
    <div class="topic">
      <p>近期活动</p>
      <p @click="urlchange('resenthd')">更多</p>
    </div>
    <div
      v-for="(item, index) in listhd"
      :key="item.id"
      style="margin-bottom: 10px"
      class="main"
      @click="linkid(item.id)"
      v-show="index < 3"
    >
      <div class="tabflexdiv" style="font-size: 14px">
        <p class="topictitle" style="font-weight: bold">{{ item.title }}</p>
        <p class="label">{{ item.type }}</p>
      </div>
      <div class="tabflexdiv">
        <div class="left">
          <div class="picdiv">
            <img :src="item.img" alt="" />
            <!-- 状态标签 -->
            <div
              class="status"
              v-show="item.zt == 1"
              :class="{ active01: item.zt == 1 }"
            >
              <p>报名中</p>
            </div>
            <div
              class="status"
              v-show="item.zt == 2"
              :class="{ active02: item.zt == 2 }"
            >
              <p>进行中</p>
            </div>
            <div
              class="status"
              v-show="item.zt == 3"
              :class="{ active03: item.zt == 3 }"
            >
              <p>已完成</p>
            </div>
            <div
              class="status"
              v-show="item.zt == 4"
              :class="{ active04: item.zt == 4 }"
            >
              <p>已过期</p>
            </div>
          </div>
          <div class="tabflexdiv" style="margin-top: 10px">
            <div @click.stop="fan(item.id, index)">
              <i v-show="item.fan == 2" class="el-icon-star-off"></i>
              <i
                v-show="item.fan == 1"
                class="el-icon-star-on"
                style="color: red"
              ></i>
              <span>点击收藏</span>
            </div>
            <div
              @click.stop="
                showShare = true;
                share(
                  item.title,
                  item.starttime_fmt,
                  item.endtime_fmt,
                  item.range_str,
                  item.address,
                  item.org_name,
                  item.total_count,
                  item.id,
                  item.img
                );
              "
            >
              <i class="el-icon-position"></i>
              <span>一键转发</span>
            </div>
          </div>
        </div>
        <div class="right">
          <p>活动开始时间：</p>
          <p>{{ timeTransevent(item.starttime) }}</p>
          <p>活动范围：{{ item.range_str }}</p>
          <p>发起组织：{{ item.org_name }}</p>
          <p>
            报名人数：{{ item.count
            }}<span v-if="item.total_count">/{{ item.total_count }}</span
            >人
          </p>
          <el-button
            v-show="item.isclose == 0 && item.btn != 0"
            type="primary"
            >{{ item.btn_str }}</el-button
          >
        </div>
      </div>
    </div>
    <!-- 分享面板 -->
    <van-share-sheet
      v-model="showShare"
      title="立即分享给好友"
      :options="options"
      @select="onShareSelect"
    />
    <!-- 分享海报 -->
    <vue-canvas-poster
      :widthPixels="1000"
      :painting="painting"
      @success="success"
      @fail="fail"
    >
    </vue-canvas-poster>
    <van-overlay
      :show="showposter"
      @click="showposter = false"
      style="text-align: center"
    >
      <img
        class="poster"
        @touchend.prevent="isAndroid && saveimg()"
        saveImage="true"
        :src="posterimg"
        alt=""
      />
    </van-overlay>
  </div>
</template>
<script>
export default {
  name: "sjdetail",
  data() {
    return {
      isAndroid: false,
      imglist: [],
      current: 0,
      total: 1,
      obj: {},
      list: [],
      listhd: [],
      listxnjg: [],
      num: 1,
      max: 1,
      showShare: false,
      options: [
        { name: "分享海报", icon: "poster" },
        { name: "其他", icon: "link" },
      ],
      painting: {
        width: `${document.documentElement.clientWidth}px`,
        height: `${document.documentElement.clientWidth * 1.6}px`,
        background: "#fff",
        views: [
          {
            //头像
            type: "image",
            id: "avater",
            url: "",
            css: {
              top: "50px",
              left: `${document.documentElement.clientWidth / 3.1}px`,
              width: `${document.documentElement.clientWidth / 2.8}px`,
              height: `${document.documentElement.clientWidth / 3.5}px`,
            },
          },
          {
            //text1 title
            type: "text",
            text: "",
            css: {
              top: [
                `${document.documentElement.clientWidth / 7 + 20}px`,
                "avater",
              ],
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "20px",
              textAlign: "center",
              maxLines: 1,
            },
          },
          {
            //text2 starttime
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 120}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
            },
          },
          {
            //text3 endtime
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 144}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
            },
          },
          {
            //text4 range
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 168}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
            },
          },
          {
            //text5 address
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 192}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
              maxLines: 1,
            },
          },
          {
            //text6 org
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 216}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
              maxLines: 1,
            },
          },
          {
            //text6 count
            type: "text",
            text: "",
            css: {
              top: `${document.documentElement.clientWidth / 3.5 + 240}px`,
              width: `${document.documentElement.clientWidth}px`,
              fontSize: "14px",
              left: "20px",
            },
          },
          {
            //rect
            type: "rect",
            text: "",
            css: {
              bottom: `100px`,
              width: `${document.documentElement.clientWidth - 40}px`,
              left: "20px",
              height: "1px",
              color: "grey",
            },
          },
          {
            //qrcode
            type: "qrcode",
            content: "",
            css: {
              bottom: "20px",
              width: "60px",
              height: "60px",
              left: "20px",
            },
          },
          {
            //icon
            type: "image",
            url: "",
            css: {
              bottom: "20px",
              right: "20px",
              width: "60px",
              height: "60px",
            },
          },
          {
            //text
            type: "text",
            text: "①长按保存图片到相册",
            css: {
              bottom: "64px",
              width: `${document.documentElement.clientWidth - 180}px`,
              fontSize: "12px",
              left: "90px",
              color: "#a1a1a1",
            },
          },
          {
            //text
            type: "text",
            text: "②打开最江阴APP扫一扫",
            css: {
              bottom: "24px",
              width: `${document.documentElement.clientWidth - 180}px`,
              fontSize: "12px",
              left: "90px",
              color: "#a1a1a1",
            },
          },
        ],
      },
      posterimg: "",
      showposter: false,
      currentshareevent: {},
      url: "",
      appId: "2312",
    };
  },
  created() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    if (isAndroid) {
      this.isAndroid = true;
    }
    this.$axios({
      method: "post",
      url: "/api/org/sj_detail",
      data: this.qs.stringify({
        id: this.$route.query.id,
      }),
    }).then((res) => {
      console.log(res.data);
      this.obj = res.data.data;
      this.list = res.data.data.news_list;
      this.listhd = res.data.data.task_list;
      this.listxnjg = res.data.data.sj_data;
      if (res.data.data.level == 1) {
        for (let i in this.listxnjg) {
          this.listxnjg[i].name = res.data.data.sj_data[i].name_suo;
          this.listxnjg[i].count = res.data.data.sj_data[i].count_zhan;
          this.listxnjg[i].id_target = res.data.data.sj_data[i].id_suo;
        }
        this.$forceUpdate();
      }
      if (res.data.data.level == 2) {
        for (let i in this.listxnjg) {
          this.listxnjg[i].name = res.data.data.sj_data[i].name_zhan;
          this.listxnjg[i].count = "";
          this.listxnjg[i].id_target = res.data.data.sj_data[i].id_zhan;
        }
        this.$forceUpdate();
      }
      this.max = Math.ceil(res.data.data.sj_data.length / 5);
      console.log(this.max);
      for (let i in res.data.data.task_list) {
        res.data.data.task_list[i].fan = 2;
        if (res.data.data.task_list[i].fav) {
          res.data.data.task_list[i].fan = 1;
        }
        switch (res.data.data.task_list[i].type) {
          case 1:
            res.data.data.task_list[i].type = "志愿者活动";
            break;
          case 2:
            res.data.data.task_list[i].type = "心愿任务";
            break;
          default:
            break;
        }
      }
    });
    var that = this;
    //app
    this.url = "//zhuzhan.ijiangyin.com/siteapp/appClient/sign";
    zjyapi.init({
      appId: that.appId,
      error: function (code, ret) {
        //失败回调,默认
        alert("初始化失败");
      },
      success: function success(ret) {
        console.log("初始化成功");
      },
    });
  },
  methods: {
    saveimg() {
      console.log("调用saveimage");
      zjyapi.saveImage(true);
    },
    changesharepic() {
      this.$axios({
        method: "post",
        url: "/api/common/uploadbaseimg",
        data: this.qs.stringify({
          base_img: this.posterimg,
        }),
      }).then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          this.posterimg = res.data.data.url;
          //this.showposter = true;
        } else {
          //this.$toast('生成海报失败，请重试');
        }
      });
    },
    /* poster */
    share(title, starttime, endtime, range, address, org, count, id, img) {
      this.currentshareevent.title = title;
      this.currentshareevent.starttime = starttime;
      this.currentshareevent.endtime = endtime;
      this.currentshareevent.range = range;
      this.currentshareevent.address = address;
      this.currentshareevent.org = org;
      this.currentshareevent.count = count;
      this.currentshareevent.id = id;
      this.currentshareevent.img = img;
    },
    beginPoster() {
      this.$set(this.painting.views[0], "url", this.currentshareevent.img);
      this.$set(this.painting.views[1], "text", this.currentshareevent.title);
      this.$set(
        this.painting.views[2],
        "text",
        "活动开始时间：" + this.currentshareevent.starttime
      );
      this.$set(
        this.painting.views[3],
        "text",
        "活动结束时间：" + this.currentshareevent.endtime
      );
      this.$set(
        this.painting.views[4],
        "text",
        "活动范围：" + this.currentshareevent.range
      );
      this.$set(
        this.painting.views[5],
        "text",
        "活动地址：" + this.currentshareevent.address
      );
      this.$set(
        this.painting.views[6],
        "text",
        "发起组织：" + this.currentshareevent.org
      );
      this.$set(
        this.painting.views[7],
        "text",
        "参与名额：" + this.currentshareevent.count + "人"
      );
      this.$set(
        this.painting.views[9],
        "content",
        "https://www.jywmsj.com/h5/#/detail?id=" + this.currentshareevent.id
      );
      this.$set(
        this.painting.views[10],
        "url",
        "https://pic-cdn.bigdatajy.com/wenming/static/img/icon3.png"
      );
      this.$toast("生成海报中");
      this.showposter = true;
    },
    success(src) {
      //console.log(src);
      this.posterimg = src;
      this.changesharepic();
    },
    fail(err) {
      console.log("fail", err);
    },
    /* posterend */
    onShareSelect(option) {
      console.log(option);
      switch (option.icon) {
        case "poster":
          console.log("poster");
          this.beginPoster();
          break;
        case "link":
          this.showShare = false;
          this.zhuanfa(
            this.currentshareevent.title,
            this.currentshareevent.id,
            this.currentshareevent.img,
            this.currentshareevent.starttime,
            this.currentshareevent.endtime,
            this.currentshareevent.range
          );
        default:
          break;
      }
      this.showShare = false;
    },
    routerto(id) {
      this.$router.push({
        name: "sjdetail",
        query: {
          id: id,
        },
      });
    },
    numminuse() {
      if (this.num > 1) {
        this.num -= 1;
      }
    },
    numadd() {
      if (this.num < this.max) {
        this.num += 1;
      }
    },
    daohang() {
      if (this.obj.lng != 0 && this.obj.lat != 0) {
        this.$router.push({
          name: "daohang",
          query: {
            lng: this.obj.lng,
            lat: this.obj.lat,
          },
        });
      } else {
        this.$toast("地址未配置");
      }
    },
    urlchange(url) {
      this.$router.push({
        name: url,
        query: {
          id: this.$route.query.id,
        },
      });
    },
    linkid(id) {
      this.$router.push({
        name: "detail",
        query: {
          id: id,
        },
      });
    },
    onChange(index) {
      console.log(index);
      this.current = index;
    },
    linketo(id, type, url) {
      if (type == 1) {
        this.$router.push({
          name: "newsdetail",
          query: {
            id: id,
          },
        });
      } else {
        this.$axios({
          method: "post",
          url: "/api/news/click",
          data: this.qs.stringify({
            id: id,
            zjy_uid: sessionStorage.getItem("uid"),
          }),
        }).then((res) => {
          console.log(res.data);
          location.href = url;
        });
      }
    },
    //收藏
    fan(id, index) {
      console.log(index);
      //未收藏状态
      if (this.listhd[index].fan == 2) {
        this.$axios({
          method: "post",
          url: "/api/task/fav",
          data: this.qs.stringify({
            task_id: id,
            type: 1,
            token: sessionStorage.getItem("wmtoken"),
          }),
        }).then((res) => {
          console.log(res.data);
          if (res.data.code == 0) {
            this.listhd[index].fan = 1;
            this.$forceUpdate();
          } else {
            this.$toast(res.data.msg);
          }
        });
      } else {
        this.$axios({
          method: "post",
          url: "/api/task/fav",
          data: this.qs.stringify({
            task_id: id,
            type: 2,
            token: sessionStorage.getItem("wmtoken"),
          }),
        }).then((res) => {
          console.log(res.data);
          if (res.data.code == 0) {
            this.listhd[index].fan = 2;
            this.$forceUpdate();
          } else {
            this.$toast(res.data.msg);
          }
        });
      }
    },
    //app相关开始
    //获取签名方法
    getSign: function (fun) {
      /*请求参数*/
      var paramObj = {
        httpUrl: this.url,
        type: "post",
        data: {
          appId: this.appId,
        },
      };
      /*请求调用*/
      this.httpRequest(paramObj, fun, function () {
        alert("获取签名失败错误");
      });
    },
    httpRequest: function (paramObj, fun, errFun) {
      var xmlhttp = null;
      /*创建XMLHttpRequest对象，
       *老版本的 Internet Explorer（IE5 和 IE6）使用 ActiveX 对象：new ActiveXObject("Microsoft.XMLHTTP")
       * */
      if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest();
      } else if (window.ActiveXObject) {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
      }
      /*判断是否支持请求*/
      if (xmlhttp == null) {
        alert("你的浏览器不支持XMLHttp");
        return;
      }
      /*请求方式，并且转换为大写*/
      var httpType = (paramObj.type || "GET").toUpperCase();
      /*数据类型*/
      var dataType = paramObj.dataType || "json";
      /*请求接口*/
      var httpUrl = paramObj.httpUrl || "";
      /*是否异步请求*/
      var async = paramObj.async || true;
      /*请求参数--post请求参数格式为：foo=bar&lorem=ipsum*/
      var paramData = paramObj.data || [];
      var requestData = "";
      for (var name in paramData) {
        requestData += name + "=" + paramData[name] + "&";
      }
      requestData =
        requestData == ""
          ? ""
          : requestData.substring(0, requestData.length - 1);
      console.log(requestData);
      /*请求接收*/
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
          /*成功回调函数*/
          //获取签名数据成功:{"serverTime":null,"error":"200","msg":"成功","data":{"appSign":"b37808616bda9d71e100e0971881101d","appId":"2312""timestamp":1575953679723},"map":null}
          console.log("获取签名数据成功:" + xmlhttp.responseText);
          var obj = JSON.parse(xmlhttp.responseText);
          var data = obj.data;
          fun({
            timestamp: data.timestamp,
            sign: data.appSign,
          });
        } else {
          /*失败回调函数*/
          errFun;
        }
      };
      /*接口连接，先判断连接类型是post还是get*/
      if (httpType == "GET") {
        xmlhttp.open("GET", httpUrl, async);
        xmlhttp.send(null);
      } else if (httpType == "POST") {
        xmlhttp.open("POST", httpUrl, async);
        //发送合适的请求头信息
        xmlhttp.setRequestHeader(
          "Content-type",
          "application/x-www-form-urlencoded"
        );
        xmlhttp.send(requestData);
      }
    },
    openShare: function (title, url, imgUrl, starttime, endtime, address) {
      var that = this;
      this.getSign(function (sign) {
        zjyapi.openShare({
          sign: sign,
          params: {
            title: title,
            content: `
            ${starttime}-${endtime}
            ${address}
            ${title}
            `,
            url: url, //分享地址
            imgUrl: imgUrl, //分享图标地址
          },
          success: function (ret) {
            console.log("分享成功：" + ret);
            var data = JSON.parse(ret);
            console.log(ret);
            console.log(data);
          },
          error: function (error) {
            console.log("分享失败：" + JSON.stringify(error));
          },
        });
      });
    },
    //app相关end
    zhuanfa(title, id, img, starttime, endtime, address) {
      this.openShare(
        title,
        "https://www.jywmsj.com/h5/#/detail?id=" + id,
        "https://www.jywmsj.com/" + img,
        starttime,
        endtime,
        address
      );
    },
  },
};
</script>
<style scoped>
.banner {
  width: 100%;
}
.van-swipe {
  width: 100%;
  height: 60vw;
}
.van-swipe img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.intro {
  padding: 5px 20px;
  line-height: 1.5em;
}
.custom-indicator {
  position: absolute;
  right: 5px;
  bottom: 5px;
  padding: 2px 5px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.1);
}
.topic {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  background: #cab586;
}
.list {
  display: flex;
  margin-bottom: 10px;
  height: 80px;
  justify-content: space-between;
  padding: 0 10px;
}
.list .left {
  width: 33%;
}
.list .left img {
  height: 100%;
  object-fit: contain;
}
.list .right {
  width: 64%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.list .flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.info {
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.book {
  height: 20px;
  width: auto;
}
.date,
.unit,
.title {
  font-size: 14px;
}
.date {
  color: grey;
  text-align: right;
}
.unit {
  text-align: right;
}
.title {
  color: blue;
}
.tabflexdiv {
  display: flex;
  justify-content: space-between;
}
.left {
  width: 40vw;
  font-size: 3vw;
}
.left img {
  height: 32vw;
  width: 100%;
  object-fit: contain;
}
.right {
  width: 53%;
  display: flex;
  flex-direction: column;
  line-height: 1.2em;
}
.right p {
  font-size: 3vw;
}
.right .el-button {
  width: 60%;
  align-self: flex-end;
  padding: 10px;
  margin-top: auto;
}
.main {
  border: 1px solid #eee;
  padding: 10px;
  background: #fffaf7;
  border-top: 4px solid #fd9292;
}
.label {
  background: #f26161;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  padding: 3px 10px;
  margin-right: -11px;
  color: white;
  white-space: nowrap;
}
.picdiv {
  position: relative;
  overflow: hidden;
}
.status {
  font-size: 12px;
  color: white;
  font-weight: bold;
  background: orange;
  text-align: center;
  position: absolute;
  top: 13%;
  left: -33%;
  width: 100%;
  padding: 2px;
  transform: rotate(-45deg);
}
.topictitle {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.active01 {
  background: orange;
}
.active02 {
  background: #7dce86;
}
.active03 {
  background: #f26161;
}
.active04 {
  background: grey;
}
.flexdiv {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
a {
  color: black;
}
.xnjg {
  display: flex;
  justify-content: space-between;
  /* align-items: center; */
  border-radius: 10px;
  background-color: #fef6f0;
  margin-bottom: 10px;
}
.xnjg .arrow {
  height: 200px;
  width: 10%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.xnjg .center {
  width: 80%;
}
.xnjg .center > div {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f2;
  padding: 10px 0;
  font-size: 14px;
}
.poster {
  width: 80%;
  border-radius: 10px;
  margin: auto;
  margin-top: 10vw;
  -webkit-touch-callout: default;
}
.suo {
  width: 50%;
  display: flex;
  margin: 10px 0;
}
.suo img {
  height: 20px;
  margin-left: 10px;
}
.suo p {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  height: 20px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/sjdetail.vue